
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[blogs]",
      function () {
        return require("private-next-pages/blogs/[blogs].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/[blogs]"])
      });
    }
  